export default __webpack_public_path__ + "static/media/bora-bike.6322a9dd.jpg";